import { MonthlyOccurrence } from '../MonthlyOccurrence';

export const YearlyOccurrence = ({ events = [], source = '', showAssigner = false }) => {
  const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  // Group events by month (0-11)
  const byMonth = {};
  events.forEach((event) => {
    const month = event.start.getMonth();
    if (!byMonth[month]) byMonth[month] = [];
    byMonth[month].push(event);
  });

  return (
    <div>
      {monthNames.map((monthName, idx) => (
        <div
          key={monthName}
          className="w-100 mb-4 rounded-2 p-2"
          style={{
            boxSizing: 'border-box',
            background: '#1e374f',
          }}
        >
          <h3 className="text-center mb-2 fw-bold">{monthName}</h3>
          <MonthlyOccurrence
            events={byMonth[idx] || []}
            source={source}
            showAssigner={showAssigner}
          />
        </div>
      ))}
    </div>
  );
};
